import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-add-new-user-level',
    templateUrl: 'dialog.addnewuserlevel.html',
    styleUrls: ['./dialog.addnewuserlevel.css']
})
export class AddNewUserLevelDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    addNewUserLevelForm: FormGroup;
    loading: boolean = false;
    errorMessage: string = '';
    datasource = [];
    selectedScreenCodeList = [];
    totalCount: number = 0;

    constructor(public dialogRef: MatDialogRef<AddNewUserLevelDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addNewUserLevelForm = new FormGroup({
            userLevelID: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
            userLevel: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(20)])
        });

        let initAddeNewSub = this.administrationService.getNewScreenCode()
            .subscribe(
                (data) => {
                    this.loading = false;
                    if (data.status === 204) {

                    } else if (data.status === 200) {
                        this.datasource = data.body['userLevelScreenCodes'];
                        this.totalCount = this.datasource.length;
                    } else {
                        this.openSnackBar('Error loading user level screen code.', '');
                    }
                },
                (error) => {
                    this.loading = false;
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(initAddeNewSub);
    }

    onSave() {
        let cfm = confirm("Are you sure you want to add new user level?");

        if (cfm) {
            this.loading = true;
            let screenCode = '';

            this.selectedScreenCodeList.forEach(element => {
                if (element['Chk'] === true) {
                    screenCode += element['ScreenCode'] + ',';
                }
            });

            let userLevelDetail = {
                UserLevelId: this.addNewUserLevelForm.get('userLevelID')!.value,
                UserLevel: this.addNewUserLevelForm.get('userLevel')!.value,
                ScnCodePrivilege: screenCode,
                Entity: ''
            }

            let save_sub = this.administrationService.addNewUserLevel(userLevelDetail)
                .subscribe(
                    (value) => {
                        this.loading = false;
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            this.dialogRef.close('Add successful');
                        } else {
                            this.openSnackBar('Error adding user level screen code.', '');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    cbOnChange(e, d, index: number) {
        let isExist = this.selectedScreenCodeList.some(a => a['ScreenCode'] === d['ScreenCode']);

        if (e.checked) {
            if (!isExist) {
                this.selectedScreenCodeList.push(d);
            }
        } else if (!e.checked) {
            if (isExist) {
                let index = this.selectedScreenCodeList.findIndex(x => x['ScreenCode'] === d['ScreenCode']);
                if (index !== -1) {
                    this.selectedScreenCodeList.splice(index, 1);
                }
            }
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}